import { Card, Notice, Text, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import TitledCard from '../../../../common/components/TitledCard';
import TopCancellationOption from './cancellation/TopCancellationOption';
import type { ScheduleChangeRefundOfferType } from './cancellation/models';
import RefundOfferDrawer from './cancellation/RefundOfferDrawer';

interface SinglePnrRefundRequestProps {
  scheduleChangeRefundOffer: ScheduleChangeRefundOfferType;
}

const SinglePnrRefundRequest = ({ scheduleChangeRefundOffer }: SinglePnrRefundRequestProps) => {
  const { t } = useTranslation();

  const cancellationOption = {
    descriptionWhenOnBottom: <Text asHtml>{t('ManageTrip.RefundRequest.Description')}</Text>,
    drawerContent: (
      <RefundOfferDrawer
        description={t('ManageTrip.RefundRequest.Drawer.Description')}
        refundOffer={scheduleChangeRefundOffer}
        title={t('ManageTrip.RefundRequest.Drawer.Title')}
      />
    ),
    expiredDescription: null,
    expiredDialogTitle: null,
    expiredDialogDescription: null,
    reason: scheduleChangeRefundOffer.refundOfferReason,
    refundOffer: null,
    title: t('ManageTrip.RefundRequest.Title'),
    descriptionWhenOnTop: t('ManageTrip.RefundRequest.Description'),
  };

  return (
    <>
      {scheduleChangeRefundOffer.expirationTimeInSec > 0 ? (
        <Card data-testid="refund-request-single-pnr">
          <TopCancellationOption
            cancellationOption={cancellationOption}
            isBestOption={false}
            isExpirationDialogOpen={false}
          />
        </Card>
      ) : (
        <TitledCard headingAs="h2" title={t('ManageTrip.RefundRequest.Expired.Title')}>
          <Notice variant="critical">
            <Text asHtml variant={textVariants._14_BOLD}>
              {t('ManageTrip.RefundRequest.Expired.Description')}
            </Text>
          </Notice>
        </TitledCard>
      )}
    </>
  );
};

export default SinglePnrRefundRequest;
